import { atom } from 'recoil';

export const ShowPlaceControlState = atom({
    key: 'ShowPlaceControlState', 
    default: true, 
});